import {observer} from 'mobx-react';
import LieuTimeNote from './LieuTimeNote';

const TotalCell = observer(({model}) => {
  return (
    <div>
      <div>{model.total}</div>
      <LieuTimeNote lieuTime={model.lieuTime}/>
    </div>
  );
});

export default TotalCell;
